// import React, { useState } from "react";
// import LogoutButton from "../../Login/LogoutButton";


// const ProfileMenu = ({ onClose, accessToken, userDetails, onCreateNewLead, onShowReports }) => {
//   const [showLogoutModal, setShowLogoutModal] = useState(false);

//   const getInitials = (name) => {
//     return name
//       ? name
//           .split(" ")
//           .map((n) => n[0])
//           .join("")
//           .toUpperCase()
//       : "";
//   };

//   return (
//     <div className="profile-menu">
//       <button className="close-btn" onClick={onClose}>✖</button>

//       <div style={{ alignItems: "center", margin: "70px 120px 11px 120px" }}>
//         <div className="profile-placeholder">
//           {getInitials(`${userDetails?.firstName} ${userDetails?.lastName}`)}
//         </div>
//       </div>

//       <h3>{userDetails?.firstName} {userDetails?.lastName}</h3>
//       <p>{userDetails?.mailid}</p>
//       <p>{userDetails?.userId}</p>

//       <select className="status-dropdown">
//         <option>Available</option>
//         <option>Break</option>
//       </select>

//       <hr />

//       <div className="profile-options" style={{ display: "grid", gap: "20px", padding: "0 20px" }}>
//         <div onClick={onCreateNewLead} style={{ cursor: "pointer" }}>Create New Leads</div>
//         <div onClick={onShowReports} style={{ cursor: "pointer" }}>Reports</div>
//         <div>Leads Assigned</div>
//         <div>Leads Converted</div>
//         <div>Profile Settings</div>
//         <div>Personal Notes</div>
//         <div>Settings</div>
//         <button onClick={() => setShowLogoutModal(true)} className="logout-btn">Logout</button>
//       </div>

//       <LogoutButton
//         isOpen={showLogoutModal}
//         onClose={() => setShowLogoutModal(false)}
//         onConfirm={() => setShowLogoutModal(false)}
//       />
//     </div>
//   );
// };

// export default ProfileMenu;
// after the change in the websocket 
import React, { useState } from "react";
import LogoutButton from "../../Login/LogoutButton";

const ProfileMenu = ({ onClose, accessToken, userDetails, onCreateNewLead, onShowReports, userStatus, setUserStatus }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const getInitials = (name) => {
    return name
      ? name
          .split(" ")
          .map((n) => n[0])
          .join("")
          .toUpperCase()
      : "";
  };

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    setUserStatus(newStatus);
  };

  return (
    <div className="profile-menu">
      <button className="close-btn" onClick={onClose}>✖</button>

      <div style={{ alignItems: "center", margin: "70px 120px 11px 120px" }}>
        <div className="profile-placeholder">
          {getInitials(`${userDetails?.firstName} ${userDetails?.lastName}`)}
        </div>
      </div>

      <h3>{userDetails?.firstName} {userDetails?.lastName}</h3>
      <p>{userDetails?.mailid}</p>
      <p>{userDetails?.userId}</p>

      <select className="status-dropdown" value={userStatus} onChange={handleStatusChange}>
        <option value="Available">Available</option>
        <option value="Break">Break</option>
      </select>

      <hr />

      <div className="profile-options" style={{ display: "grid", gap: "20px", padding: "0 20px" }}>
        <div onClick={onCreateNewLead} style={{ cursor: "pointer" }}>Create New Leads</div>
        <div onClick={onShowReports} style={{ cursor: "pointer" }}>Reports</div>
        <div>Leads Assigned</div>
        <div>Leads Converted</div>
        <div>Profile Settings</div>
        <div>Personal Notes</div>
        <div>Settings</div>
        <button onClick={() => setShowLogoutModal(true)} className="logout-btn">Logout</button>
      </div>

      <LogoutButton
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={() => setShowLogoutModal(false)}
      />
    </div>
  );
};

export default ProfileMenu;